/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Typography from '@material-ui/core/Typography';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';

export default function ClinicianMappingForm({ props }) {
  const [state, setState] = useState({ username: props.selectedRow[4] || '' });
  const [propsState] = useState({
    clinicianId: props.selectedRow[0],
    fullName: `${props.selectedRow[1]} ${props.selectedRow[2]}`,
    username: props.selectedRow[4] || '',
  });

  const canSave = state.username && state.username !== '';
  const clinicianId = propsState.clinicianId;
  const fullName = propsState.fullName;
  const username = propsState.username;
  const locale = props.events.locale;

  return (
    <section className="side-panel-content-wrapper">
      <SwipeableDrawer anchor="right" open onOpen={() => {}} onClose={() => {}}>
        <div className="sidePanel-wrapper" style={{ width: '400px' }}>
          <div className="sidePanel-header form-header">
            <div className="sidePanel-header-subtitle">
              <Box display="flex">
                <Box flexGrow={1} py={1}>
                  <Typography variant="subtitle1">{locale.getMsg('clinicianUsernameMapping')}</Typography>
                </Box>
                <Box>
                  <IconButton onClick={() => props.events.onClose()}>
                    <CancelIcon />
                  </IconButton>
                </Box>
              </Box>
            </div>
          </div>
          <div className="sidePanel-content content-top-padding">
            <Typography variant="h6" gutterBottom>
              {locale.getMsg('clinicianForenameSurname')}
            </Typography>
            <TextField fullWidth value={fullName} disabled />
            <Typography variant="h6" gutterBottom className="text-as-separator">
              {locale.getMsg('mapToUsername')}
            </Typography>
            <TextField
              name="username"
              value={state.username}
              fullWidth
              onChange={e => setState({ ...state, username: e.target.value })}
            />
          </div>
          <span className="form-validation-error">
            {props.errorMsg ? props.errorMsg.message.split('\n').map((it, i) => <p key={i}>{it}</p>) : null}
          </span>
          <div className="sidePanel-footer">
            <div className="sidePanel-buttons">
              <div className="sidePanel-BackButton">
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => props.events.onClose()}
                  style={{ marginRight: '10px' }}
                >
                  {locale.getMsg('back')}
                </Button>
              </div>
              <div className="sidePanel-saveButton">
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!canSave}
                  onClick={() => {
                    if (username !== state.username) {
                      props.events.editClinicianMappingModel({ clinicianId, username: state.username });
                    } else {
                      props.events.handleSidePanel(false);
                    }
                  }}
                >
                  {locale.getMsg('edit')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </SwipeableDrawer>
    </section>
  );
}
